import {getTracer} from '@techsee/techsee-common/lib/core/Tracer';

export const DASHBOARD_APP_TRACER = 'DashboardTracer';

export function getAppTracer(namePostFix: string) {
    return getTracer(DASHBOARD_APP_TRACER, namePostFix);
}
